module.exports = __webpack_public_path__ + "/images/nosotros-portada.d390801.jpg";